import {
  trigger,
  transition,
  style,
  query,
  group,
  animate,
  animateChild,
} from '@angular/animations';

// Positioned
export const slider =
  trigger('routeAnimations', [
    // more component
    transition('more => licenses', slideTo('right')),
    transition('licenses => more', slideTo('left')),
    transition('more => preferences', slideTo('right')),
    transition('preferences => more', slideTo('left')),
    transition('more => xpac-management', slideTo('right')),
    transition('xpac-management => more', slideTo('left')),
    transition('xpac-info => xpac-management', slideTo('left')),
    transition('xpac-management => xpac-info', slideTo('right')),
    transition('more => impersonation', slideTo('right')),
    transition('impersonation => more', slideTo('left')),
    transition('more => argus-calculator', slideTo('right')),
    transition('argus-calculator => more', slideTo('left')),
    transition('more => logistics', slideTo('right')),
    transition('logistics => more', slideTo('left')),
    transition('more => firmware', slideTo('right')),
    transition('firmware => more', slideTo('left')),
    transition('more => password', slideTo('right')),
    transition('password => more', slideTo('left')),
    transition('more => documents', slideTo('right')),
    transition('documents => more', slideTo('left')),
    transition('more => insights', slideTo('right')),
    transition('insights => more', slideTo('left')),
    transition('insights => insights-reports-settings', slideTo('right')),
    transition('insights-reports-settings => insights', slideTo('left')),
    transition('more => production-tooling', slideTo('right')),
    transition('production-tooling => more', slideTo('left')),
    transition('more => products', slideTo('right')),
    transition('products => more', slideTo('left')),

    transition('more => companies', slideTo('right')),
    transition('companies => more', slideTo('left')),
    transition('companies => company', slideTo('right')),
    transition('company => companies', slideTo('left')),

    transition('more => users', slideTo('right')),
    transition('users => more', slideTo('left')),
    transition('users => user', slideTo('right')),
    transition('user => users', slideTo('left')),
    transition('more => user', slideTo('right')),
    transition('user => more', slideTo('left')),

    transition('company => user', slideTo('right')),
    transition('user => company', slideTo('left')),

    transition('users => user', slideTo('right')),
    transition('user => users', slideTo('left')),

    transition('more => inventory-management', slideTo('right')),
    transition('inventory-management => more', slideTo('left')),

    transition('inventory-management => im-device-details', slideTo('right')),
    transition('im-device-details => inventory-management', slideTo('left')),

    transition('more => unlock', slideTo('right')),
    transition('unlock => more', slideTo('left')),

    // default just an animate 0
    transition('* => *', [animate(0)]),
  ]);


function slideTo(direction: string) {

  const optional = { optional: true };
  return [
    style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        [direction]: 0,
        width: '100%'
      })
    ], optional),
    query(':enter', [
      style({ [direction]: '-100%' })
    ]),
    query(':leave', animateChild()),
    group([
      query(':leave', [
        animate('400ms ease', style({ [direction]: '100%' }))
      ], optional),
      query(':enter', [
        animate('400ms ease', style({ [direction]: '0%' }))
      ], optional)
    ]),
  ];
}
